import querystring from "query-string";

export const AdminPaths = {
  AdminDashboard: "/AdminDashboard",
  ManageAccounts: "/ManageAccounts",
  ApplicationDetails: ({ app }: { app: { id: number | string } }) =>
    `/ApplicationDetails/${app.id}`,
  ApproveOrDenyPurchase: (args: { adminApprovalKey: string }) =>
    `/ApproveOrDenyPurchase/${args.adminApprovalKey}`,
  PurchaseApproved: (args: { adminApprovalKey: string }) =>
    `/PurchaseApproved/${args.adminApprovalKey}`,
  PurchaseDenied: (args: { adminApprovalKey: string }) =>
    `/PurchaseDenied/${args.adminApprovalKey}`,
  SearchResults: ({
    searchText,
    page,
  }: {
    searchText: string;
    page?: number;
  }) => `/SearchResults?${querystring.stringify({ searchText, page })}`,
};

export const PublicPaths = {
  Error: "/Error",
  ChangePassword: "/ChangePassword",
  CreateNewPassword: "/CreateNewPassword",
  ForgotPassword: "/ForgotPassword",
  LogIn: "/LogIn",
};
